// Deixa maiúscula só a primeira letra — usado em textos que vêm de
// toLocaleDateString/toLocaleTimeString em minúsculo (ex: "sexta-feira, 14
// de agosto"). `text-transform: capitalize` no CSS faz isso errado: deixa
// TODA palavra maiúscula, inclusive preposição ("De Agosto"), o que não
// existe em português.
export function capitalizarPrimeira(texto) {
  if (!texto) return texto;
  return texto.charAt(0).toUpperCase() + texto.slice(1);
}
